import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class CenterIconList extends mixin(Model, {
  pkgId: Model.attribute('pkgId'),
  iconName: Model.attribute('iconName'),
  iconImg: Model.attribute('iconImg'),
  iconLink: Model.attribute('iconLink'),
  sortcount: Model.attribute('sortcount'),
}) {
    // constructor(...args) {
    //   super(...args);
    //   this.centerIconList = [{
    //     iconName: Model.attribute('iconName'),
    //     iconImg: Model.attribute('iconImg'),
    //     iconLink: Model.attribute('iconLink'),
    //   }];
    // }
  apiEndpoint() {
    return '/centerIconList' + (this.exists ? '/' + this.data.id : '');
  }
}
